import React, { useEffect, useState, useRef, useCallback, createContext } from "react";
import { Col, Row } from "react-bootstrap";
import "../Spot/Spot.css";

import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import FutureLeftTable from "./FutureLeftTable";
import FutureChart from "./FutureChart";
import FutureRightTable from "./FutureRightTable";
import FutureBottomTable from "./FutureBottomTable";
import FutureBuyAndSell from "./FutureBuySell";
import FutureMarginHoldings from "./FutureMarginHoldings";
import FutureTopMovers from "./FutureTopMovers";
import {
  getFuturesLayoutMatrix,
  FUTURES_COMPONENTS,
} from "./futureLayoutConfig";
import FlipNumbers from "react-flip-numbers";
import { WEBSERVICE, checkInternetConnection } from "../../CoreDataService";
import { Box, Typography, Tooltip, IconButton, alpha } from "@mui/material";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import { useSelector } from "react-redux";
import { useTradingColors, setTradingColorPreference } from "../Spot/tradingColorConfig";
import { syncExchangeSettingsOnLoad } from "../Spot/exchangeSettingsService";
import { setSpotLayoutPreset } from "../Spot/spotLayoutConfig";
import SpotLayoutDrawer from "../Spot/SpotLayoutDrawer";

export const FutureDataContent = createContext();

const FuturesDashboard = () => {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const { upColor, downColor, pairButtonColor } = useTradingColors();
  const [isLayoutDrawerOpen, setIsLayoutDrawerOpen] = useState(false);
  const [layoutMatrix, setLayoutMatrix] = useState(() => getFuturesLayoutMatrix());
  const [rowHeights, setRowHeights] = useState({});
  const masterRefs = useRef({});
  const observerRef = useRef(null);
  const [isConnected, setIsConnected] = useState(true);
  const [data, setData] = useState({});
  const [title, setTitle] = useState("angulartitle");
  const [chartData, setChartData] = useState(null);
  const [ltp, setLtp] = useState(null);
  const [markPrice, setMarkPrice] = useState(null);
  const [indexPrice, setIndexPrice] = useState(null);
  const [rocData, setRocData] = useState(0);
  const [volumnData, setVolumnData] = useState(0);
  const [lowPrice, setLowPrice] = useState(0);
  const [highPrice, setHighPrice] = useState(0);
  const [action, setAction] = useState("");
  const [isNegative, setIsNegative] = useState(false);
  const [isRocReact, setIsRocReact] = useState(false);
  const [themeColor, setThemeColor] = useState("light");
  const [finalBiddata, setFinalBiddata] = useState([]);
  const [finalAskdata, setFinalAskdata] = useState([]);
  const [lastAskItem, setLastAskItem] = useState(null);
  const [firstBidItem, setFirstBidItem] = useState(null);
  const [derivativeAssets, setDerivativeAssets] = useState();
  const [updateBalance, setUpdateBalance] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currencycode, setCurrencycode] = useState(
    localStorage.getItem("derivative_buying_crypto_asset") || "BTC"
  );
  const [basecurrency, setBasecurrency] = useState("USDT");

  const [assetpair, setAssetPair] = useState(
    localStorage.getItem("selected_derivative_asset_pair") || "BTCUSDT_PERP"
  );
  const [assetPairName, setAssetPairName] = useState(
    localStorage.getItem("selected_derivative_asset_pair_name") ||
    "BTCUSDT Perpetual"
  );

  const [balanceList, setBalanceList] = useState([]);
  const [currencyBalance, setCurrencyBalance] = useState([]);
  const [newFiatArray, setNewFiatArray] = useState([]);

  const [message, setMessage] = useState(null); // Store received messages
  const [connected, setConnected] = useState(false); // Connection status
  const stompClientRef = useRef(null); // Store the Stomp client instance
  const [buyingAsset, setBuyingAsset] = useState(
    localStorage.getItem("buying_crypto_asset") || "BTC"
  );
  const [sellingAsset, setSellingAsset] = useState(
    localStorage.getItem("selling_crypto_asset") || "USD"
  );
  const [sellData, setSellData] = useState("");
  const [buyData, setBuyData] = useState("");

  const allProps = {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    setCurrencycode,
    setBasecurrency,
    currencycode,
    basecurrency,
    setAssetPair,
    lowPrice,
    highPrice,
    assetpair,
    setAssetPairName,
    setDerivativeAssets,
    refresh,
    newFiatArray,
    finalBiddata,
    finalAskdata,
    lastAskItem,
    firstBidItem,
    setLastAskItem,
    setFirstBidItem,
    ltp,
    assetPairName,
    assetpair,
    derivativeAssets,
    updateBalance,
    setRefresh,
    setSellData,
    setBuyData,
    sellData,
    buyData,
    setUpdateBalance,
  };

  const [reqNo, setReqNo] = useState(Math.floor(Math.random() * 1000) + 1);
  const websocketRef = useRef(null);
  const webSocketEndPoint =
    "https://futures-stream.paybito.com/fSocketStream/ws";
  const topic = "/user/topic/stream";
  let stompClient = null;

  const changeMessage = (msg) => {
    setMessage(msg);
  };

  const connectWebSocket = () => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClientRef.current = Stomp.over(ws);
      stompClientRef.current.debug = null;

      stompClientRef.current.connect(
        {},
        (frame) => {
          if (stompClientRef.current && stompClientRef.current.connected) {
            stompClientRef.current.subscribe(topic, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });
            subscribe(); // Ensure this doesn't rely on an unready connection
          } else {
            console.error("STOMP connection not ready yet.");
          }
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (!stompClientRef.current || !stompClientRef.current.connected) {
      console.error("WebSocket is not connected yet.");
      return;
    }

    stompClientRef.current.send(
      "/app/sendRequest",
      {},
      JSON.stringify(message)
    );
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    console.log("socketData", assetpair, parsedMessage);
    changeMessage(parsedMessage); // Store message
    const data = parsedMessage.tR;
    if (data !== null) {
      setChartData(data);
      // setMarkPrice(parseFloat(data?.markPrice)?.toFixed(2));
      // setIndexPrice(parseFloat(data?.indexPrice)?.toFixed(2));
      setLowPrice(parseFloat(data?.lowPrice)?.toFixed(2));
      setHighPrice(parseFloat(data?.highPrice)?.toFixed(2));
      setAction(data?.action);
      setRocData(parseFloat(data?.roc).toFixed(2));
      setVolumnData(parseFloat(data?.volume).toFixed(2));
      setIsRocReact(data?.roc > 0);
      setIsNegative(data?.roc < 0);
      setTitle(
        `${data?.ltp} | ${buyingAsset}${sellingAsset} | ${data?.exchange}`
      );
    }
  };

  const subscribe = () => {
    const assetPair = localStorage
      .getItem("selected_derivative_asset_pair")
      ?.toLowerCase();
    localStorage.setItem("lastAssetPair", assetPair);

    const ticker = "@ticker";
    const depth = "@depth";
    const trade = "@trade";
    const reqNo = Math.floor(Math.random() * 1000) + 1;

    const req = {
      method: "SUBSCRIBE",
      params: [assetpair + ticker, assetpair + depth, assetpair + trade],
      id: reqNo,
    };
    setTimeout(() => {
      sendMessage(req);
    }, 10000);
  };

  const disconnectWebSocket = () => {
    if (stompClientRef.current && stompClientRef.current.connected) {
      stompClientRef.current.disconnect(() => {
        console.log("Disconnected");
      });
    } else {
      console.warn("Disconnect skipped: STOMP client not connected.");
    }
  };

  useEffect(() => {
    fetchTickerData();

    return () => {
      if (websocketRef.current) {
        disconnectWebSocket(); // Disconnect WebSocket when the component unmounts
      }
      disconnectWebSocket();
    };
  }, [assetpair, currencycode]);
  useEffect(() => {
    getUserBalance();
  }, [assetpair, currencycode]);

  useEffect(() => {
    // Call the function and get the cleanup function
    const cleanup = checkInternetConnection(setIsConnected);

    // Cleanup listeners when component unmounts
    return () => cleanup();
  }, []);

  const measureElementContentHeight = (el) => {
    if (!el) return 0;
    if (el.children && el.children.length > 0) {
      let totalH = 0;
      for (let i = 0; i < el.children.length; i++) {
        const child = el.children[i];
        const style = window.getComputedStyle(child);
        const mt = parseFloat(style.marginTop) || 0;
        const mb = parseFloat(style.marginBottom) || 0;
        totalH += child.offsetHeight + mt + mb;
      }
      if (totalH >= 500) {
        return Math.round(totalH);
      }
    }
    return el.offsetHeight >= 500 ? el.offsetHeight : 0;
  };

  // Register master column ref for dynamic row height calculation
  const registerMasterRef = useCallback((rowKey, node) => {
    if (!observerRef.current) {
      observerRef.current = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const target = entry.target;
          const key = target.dataset?.rowKey || target.closest?.("[data-row-key]")?.dataset?.rowKey;
          if (key) {
            const h = measureElementContentHeight(target);
            if (h >= 500) {
              setRowHeights((prev) => (prev[key] === h ? prev : { ...prev, [key]: h }));
            }
          }
        }
      });
    }

    if (masterRefs.current[rowKey] === node) {
      return;
    }

    if (masterRefs.current[rowKey] && masterRefs.current[rowKey] !== node) {
      try {
        observerRef.current.unobserve(masterRefs.current[rowKey]);
      } catch (e) {}
    }

    masterRefs.current[rowKey] = node;

    if (node) {
      node.dataset.rowKey = rowKey;
      observerRef.current.observe(node);
      if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
          const child = node.children[i];
          child.dataset.rowKey = rowKey;
          observerRef.current.observe(child);
        }
      }
      const initialH = measureElementContentHeight(node);
      if (initialH >= 500) {
        setRowHeights((prev) => (prev[rowKey] === initialH ? prev : { ...prev, [rowKey]: initialH }));
      }
    }
  }, []);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  // Dynamically sync user's active layout & color with Spot dashboard settings
  useEffect(() => {
    // Clean up any old divergent futures-specific preset so layout strictly mirrors Spot
    localStorage.removeItem("admin_futures_layout_preset");
    localStorage.removeItem("admin_futures_layout_matrix");

    const currentSpotPreset = localStorage.getItem("admin_spot_layout_preset") || "DEFAULT";
    const currentColor = localStorage.getItem("spot_color_preference") || "FRESH";

    syncExchangeSettingsOnLoad({
      currentPresetId: currentSpotPreset,
      onSetPreset: (presetId) => {
        setSpotLayoutPreset(presetId);
        setLayoutMatrix(getFuturesLayoutMatrix());
      },
      currentColorId: currentColor,
      onSetColor: (colorId) => {
        setTradingColorPreference(colorId);
      },
    });
  }, []);

  // Listen to Spot layout changes in real-time so Futures immediately reflects it
  useEffect(() => {
    const handleLayoutUpdate = () => {
      setLayoutMatrix(getFuturesLayoutMatrix());
    };

    window.addEventListener("spot_layout_change", handleLayoutUpdate);
    window.addEventListener("futures_layout_change", handleLayoutUpdate);

    const handleStorageChange = (e) => {
      if (e.key === "admin_spot_layout_preset") {
        setLayoutMatrix(getFuturesLayoutMatrix());
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("spot_layout_change", handleLayoutUpdate);
      window.removeEventListener("futures_layout_change", handleLayoutUpdate);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const renderDashboardComponent = (componentKey, compConfig = {}) => {
    switch (componentKey) {
      case FUTURES_COMPONENTS.ORDER_BOOK:
        return <FutureLeftTable />;
      case FUTURES_COMPONENTS.TRADE_HISTORY:
        return <FutureRightTable {...(compConfig?.props || {})} />;
      case FUTURES_COMPONENTS.CHART:
        return <FutureChart />;
      case FUTURES_COMPONENTS.BUY_SELL:
        return <FutureBuyAndSell />;
      case FUTURES_COMPONENTS.BOTTOM_TABLE:
        return <FutureBottomTable />;
      case FUTURES_COMPONENTS.MARGIN_HOLDINGS:
        return <FutureMarginHoldings />;
      case FUTURES_COMPONENTS.TOP_MOVERS:
        return <FutureTopMovers {...(compConfig?.props || {})} />;
      default:
        return null;
    }
  };

  const fetchTickerData = () => {
    let selectedPair = localStorage.getItem("selected_derivative_asset_pair");
    let selectedPairName = localStorage.getItem(
      "selected_derivative_asset_pair_name"
    );

    if (!selectedPair || !selectedPairName) {
      selectedPair = "BTCUSDT_PERP";
      selectedPairName = "BTCUSDT Perpetual";
      localStorage.setItem("selected_derivative_asset_pair", selectedPair);
      localStorage.setItem(
        "selected_derivative_asset_pair_name",
        selectedPairName
      );
    }

    axios
      .get(
        `https://futures-stream.paybito.com/fSocketStream/api/get24hTicker?assetPair=${assetpair}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result && result.length) {
          const data = result[0];
          setChartData(data);
          setMarkPrice(parseFloat(data.markPrice).toFixed(2));
          setIndexPrice(parseFloat(data.indexPrice).toFixed(2));
          setLtp(data?.ltp);
          setLowPrice(parseFloat(data.lowPrice).toFixed(2));
          setHighPrice(parseFloat(data.highPrice).toFixed(2));
          setAction(data.action);
          setRocData(parseFloat(data.roc).toFixed(2));
          setVolumnData(parseFloat(data.volume).toFixed(2));
          setIsRocReact(data.roc > 0);
          setIsNegative(data.roc < 0);
          setTitle(`${data?.ltpdata} | BTCUSDT Perpetual | ${data?.exchange}`);
        }

        // websocketRef.current = {
        //   socket: null,
        //   subscribeMessage: null,
        // };

        disconnectWebSocket();

        connectWebSocket();

        // websocketRef.current.subscribeMessage = (message) => {
        //   console.log("socketData message---->", assetpair, message);
        //   const data = message.tR;

        //   if (data !== null) {
        //     setChartData(data);
        //     // setMarkPrice(parseFloat(data?.markPrice)?.toFixed(2));
        //     // setIndexPrice(parseFloat(data?.indexPrice)?.toFixed(2));
        //     setLowPrice(parseFloat(data?.lowPrice)?.toFixed(2));
        //     setHighPrice(parseFloat(data?.highPrice)?.toFixed(2));
        //     setAction(data?.action);
        //     setRocData(parseFloat(data?.roc).toFixed(2));
        //     setVolumnData(parseFloat(data?.volume).toFixed(2));
        //     setIsRocReact(data?.roc > 0);
        //     setIsNegative(data?.roc < 0);
        //     setTitle(
        //       `${data?.ltp} | ${buyingAsset}${sellingAsset} | ${data?.exchange}`
        //     );
        //   }
        // };
      })
      .catch((error) => {
        console.error("Error fetching 24h ticker data manually:", error);
      });
  };

  console.log("chartData", chartData?.ltp, assetpair);

  const getUserBalance = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("user_id"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      const list = result.userBalanceList;
      setBalanceList(list);
      setCurrencyBalance(list);

      if (list != null) {
        const fiatCurrencies = list
          .filter((item) => item.currencyType === 1)
          .map((item) => item.currencyCode);

        setNewFiatArray(fiatCurrencies);
        console.log("new fiat data", fiatCurrencies);
      }
    } catch (error) {
      console.warn("Error fetching balance:", error.message);
    }
  };

  return (
    <FutureDataContent.Provider value={allProps}>
      <Box sx={pageWrapper}>

        {/* ── Ticker Strip ── */}
        <Box sx={tickerStrip}>

          {/* Left — Pair badge */}
          <Box sx={tickerPairBadge}>
            <Box sx={tickerPairIconWrap}>
              <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff" }} />
            </Box>
            <Box>
              <Typography sx={tickerPairText}>
                {assetPairName}
              </Typography>
              <Typography sx={tickerPairSub}>Futures</Typography>
            </Box>
          </Box>

          {/* Center — Stats */}
          <Box sx={tickerStatsCenter}>
            <Box sx={tickerDivider} />

            {/* Last Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>LAST PRICE</Typography>
              <Typography sx={{ ...tickerStatValue, color: isNegative ? downColor : upColor, fontWeight: 800, fontSize: "1rem" }}>
                <FlipNumbers
                  height={14}
                  width={9}
                  play
                  duration={2}
                  numbers={Number(chartData?.ltp).toLocaleString(undefined, {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}
                />
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* MTM (Mark Price) */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>MTM</Typography>
              <Typography sx={tickerStatValue}>{markPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* Index Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>INDEX</Typography>
              <Typography sx={tickerStatValue}>{indexPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Change */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H CHANGE</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                {isNegative
                  ? <TrendingDownOutlinedIcon sx={{ fontSize: 13, color: downColor }} />
                  : <TrendingUpOutlinedIcon sx={{ fontSize: 13, color: upColor }} />}
                <Typography sx={{ ...tickerStatValue, color: isNegative ? downColor : upColor }}>
                  {rocData}%
                </Typography>
              </Box>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H VOL</Typography>
              <Typography sx={tickerStatValue}>{volumnData}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H High */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H HIGH</Typography>
              <Typography sx={{ ...tickerStatValue, color: upColor }}>{highPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Low */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H LOW</Typography>
              <Typography sx={{ ...tickerStatValue, color: downColor }}>{lowPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />
          </Box>

          {/* Right — Connection status & Layout Settings */}
          <Box sx={tickerConnectionWrap}>
            {/* Layout Setting button just before the LIVE badge */}
            <Tooltip title="Layout Settings" placement="bottom">
              <IconButton
                size="small"
                onClick={() => setIsLayoutDrawerOpen(true)}
                sx={{
                  color: isLayoutDrawerOpen ? (btncolor || "#F0B90B") : "var(--text-color)",
                  opacity: isLayoutDrawerOpen ? 1 : 0.8,
                  mr: 1,
                  p: "5px",
                  borderRadius: "6px",
                  border: isLayoutDrawerOpen
                    ? `1px solid ${btncolor || "#F0B90B"}`
                    : "1px solid rgba(125,125,125,0.22)",
                  backgroundColor: isLayoutDrawerOpen
                    ? alpha(btncolor || "#F0B90B", 0.12)
                    : "rgba(125,125,125,0.08)",
                  transition: "all 0.15s ease",
                  "&:hover": {
                    opacity: 1,
                    color: btncolor || "#F0B90B",
                    borderColor: alpha(btncolor || "#F0B90B", 0.4),
                    backgroundColor: alpha(btncolor || "#F0B90B", 0.12),
                  },
                }}
              >
                <TuneIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>

            <Box sx={tickerConnectionPill}>
              <Box
                sx={{
                  width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                  backgroundColor: isConnected ? upColor : downColor,
                  boxShadow: isConnected ? `0 0 5px ${upColor}` : `0 0 5px ${downColor}`,
                  animation: isConnected ? "tickerPulse 2s ease-in-out infinite" : "none",
                }}
              />
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: isConnected ? upColor : downColor, letterSpacing: "0.06em" }}>
                {isConnected ? "LIVE" : "OFFLINE"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Main Trading Layout (Rendered from Matrix) ── */}
        <Box sx={tradingLayout}>
          {layoutMatrix.map((rowConfig, rIdx) => {
            const rowKey = rowConfig.rowId || `row-${rIdx}`;
            const isTableOnlyCol = (col) =>
              col.components.every(
                (c) =>
                  c.key === FUTURES_COMPONENTS.ORDER_BOOK ||
                  c.key === FUTURES_COMPONENTS.TRADE_HISTORY
              );
            const hasMultipleCols = rowConfig.columns && rowConfig.columns.length > 1;
            const hasTableCol = hasMultipleCols && rowConfig.columns.some(isTableOnlyCol);
            const hasChartAndBuySellInRow = rowConfig.columns && rowConfig.columns.some(
              (col) =>
                col.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                col.components.some((c) => c.key === FUTURES_COMPONENTS.BUY_SELL)
            );
            const masterCol = hasTableCol
              ? rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                    col.components.some((c) => c.key === FUTURES_COMPONENTS.BUY_SELL)
                ) ||
                rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === FUTURES_COMPONENTS.BUY_SELL) &&
                    col.components.length > 1
                ) ||
                rowConfig.columns.find(
                  (col) =>
                    col.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                    !col.components.some((c) => c.key === FUTURES_COMPONENTS.TOP_MOVERS) &&
                    !col.components.some((c) => c.key === FUTURES_COMPONENTS.TRADE_HISTORY)
                )
              : null;
            const syncedHeight = Math.max(rowHeights[rowKey] || 882, 600);

            return (
              <Row
                key={rowKey}
                className={rowConfig.className || ""}
                style={{ margin: 0, flex: 1, alignItems: "flex-start", ...(rowConfig.style || {}) }}
              >
                {rowConfig.columns.map((colConfig, cIdx) => {
                  const isMaster = masterCol && colConfig === masterCol;
                  const isTable = hasTableCol && isTableOnlyCol(colConfig);
                  const isStackedBuySell =
                    (colConfig.colId === "col-right-buysell" ||
                      colConfig.colId === "col-left-buysell" ||
                      colConfig.colId === "col-buysell-side" ||
                      colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.MARGIN_HOLDINGS)) &&
                    colConfig.components.length > 1;
                  const isChartOnly =
                    colConfig.components.length === 1 &&
                    colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.CHART);
                  const isStackedChartOrders =
                    colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                    colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.BOTTOM_TABLE);
                  const isStackedChartMovers =
                    colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                    colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.TOP_MOVERS);
                  const shouldSyncHeight = hasChartAndBuySellInRow
                    ? !isMaster && (isTable || isStackedBuySell)
                    : (isTable || isStackedBuySell || isChartOnly || isStackedChartOrders || isStackedChartMovers);
                  const dynamicHeightStyle =
                    shouldSyncHeight && syncedHeight
                      ? { height: `${syncedHeight}px`, maxHeight: `${syncedHeight}px` }
                      : {};

                  const hasOrderBook = colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.ORDER_BOOK);

                  return (
                    <Col
                      key={colConfig.colId || `col-${rIdx}-${cIdx}`}
                      ref={isMaster ? (el) => registerMasterRef(rowKey, el) : undefined}
                      xs={colConfig.size?.xs || 12}
                      sm={colConfig.size?.sm}
                      md={colConfig.size?.md || 12}
                      lg={colConfig.size?.lg}
                      className={colConfig.className || "mb-1 p-0"}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        overflow: hasOrderBook ? "visible" : "hidden",
                        zIndex: hasOrderBook ? 100 : 1,
                        position: "relative",
                        ...(isMaster && hasChartAndBuySellInRow ? { alignSelf: "flex-start" } : {}),
                        ...(colConfig.style || {}),
                        ...dynamicHeightStyle,
                      }}
                    >
                      {colConfig.components.map((comp) => {
                        const isChart = comp.key === FUTURES_COMPONENTS.CHART;
                        const isBuySell = comp.key === FUTURES_COMPONENTS.BUY_SELL;
                        const isMarginHoldings = comp.key === FUTURES_COMPONENTS.MARGIN_HOLDINGS;
                        const isOrderBook = comp.key === FUTURES_COMPONENTS.ORDER_BOOK;
                        const isTradeHistory = comp.key === FUTURES_COMPONENTS.TRADE_HISTORY;
                        const isOnlyComponent = colConfig.components.length === 1;

                        const hasChartAndBuySell =
                          colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                          colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.BUY_SELL);

                        const isStackedChartMovers =
                          colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.CHART) &&
                          colConfig.components.some((c) => c.key === FUTURES_COMPONENTS.TOP_MOVERS);

                        const compFlex =
                          comp.flex !== undefined
                            ? comp.flex
                            : isOnlyComponent
                              ? 1
                              : hasChartAndBuySell
                                ? (isChart ? "none" : "0 0 auto")
                                : isStackedChartOrders
                                  ? (isChart ? "1.4 1 0%" : "1 1 0%")
                                  : isStackedChartMovers
                                    ? (isChart ? 1 : "none")
                                    : (isBuySell || isMarginHoldings)
                                      ? 1
                                      : 1;
                        const compHeight =
                          comp.height !== undefined
                            ? comp.height
                            : isOnlyComponent
                              ? "100%"
                              : hasChartAndBuySell
                                ? (isChart ? "508px" : "auto")
                                : isStackedChartOrders
                                  ? (isChart ? "calc(58% - 3px)" : "calc(42% - 3px)")
                                  : isStackedChartMovers
                                    ? (isChart ? "calc(100% - 216px)" : "210px")
                                    : "50%";
                        const compMinHeight =
                          comp.minHeight !== undefined
                            ? comp.minHeight
                            : isOnlyComponent
                              ? 0
                              : hasChartAndBuySell
                                ? (isChart ? 508 : 0)
                                : isStackedChartMovers
                                  ? (isChart ? 400 : 0)
                                  : isChart
                                    ? 440
                                    : (isBuySell || isMarginHoldings)
                                      ? 396
                                      : 0;
                        const compMaxHeight =
                          comp.maxHeight !== undefined
                            ? comp.maxHeight
                            : isStackedChartMovers && !isChart
                              ? "210px"
                              : undefined;

                        return (
                          <Box
                            key={comp.key}
                            sx={{
                              ...panelCard,
                              ...(isTradeHistory
                                ? {
                                    "& .custom-select": {
                                      cursor: "pointer",
                                    },
                                  }
                                : {}),
                              display: "flex",
                              flexDirection: "column",
                              flex: compFlex,
                              height: compHeight,
                              minHeight: compMinHeight,
                              maxHeight: compMaxHeight,
                              overflow: isOrderBook ? "visible" : "hidden",
                              position: "relative",
                              ...(comp.sx || {}),
                            }}
                          >
                            {renderDashboardComponent(comp.key, comp)}
                          </Box>
                        );
                      })}
                    </Col>
                  );
                })}
              </Row>
            );
          })}
        </Box>

        {/* ── Binance-Style Global Layout Settings Drawer ── */}
        <SpotLayoutDrawer
          open={isLayoutDrawerOpen}
          onClose={() => setIsLayoutDrawerOpen(false)}
        />
      </Box>
    </FutureDataContent.Provider>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

const tickerStrip = {
  display: "flex",
  alignItems: "center",
  flexWrap: { xs: "wrap", md: "nowrap" },
  justifyContent: "space-between",
  px: { xs: "12px", md: "14px" },
  py: { xs: "8px", md: "10px" },
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

const tickerStatsCenter = {
  flex: { xs: "0 0 100%", md: 1 },
  width: { xs: "100%", md: "auto" },
  order: { xs: 3, md: 2 },
  mt: { xs: "8px", md: 0 },
  pt: { xs: "6px", md: 0 },
  borderTop: { xs: "1px solid rgba(125,125,125,0.12)", md: "none" },
  display: "flex",
  alignItems: "center",
  justifyContent: { xs: "flex-start", md: "center" },
  gap: { xs: "14px", md: 0 },
  overflowX: { xs: "auto", md: "hidden" },
  overflowY: "hidden",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": { display: "none" },
  WebkitOverflowScrolling: "touch",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
  flexShrink: 0,
  order: { xs: 1, md: 1 },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};

const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};

const tickerPairSub = {
  fontSize: "0.6rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.4,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};

const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  flexShrink: { xs: 0, md: 1 },
  pr: { xs: 0, md: "16px" },
  minWidth: { xs: "max-content", md: "auto" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
  whiteSpace: "nowrap",
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  order: { xs: 2, md: 3 },
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

const tradingLayout = {
  px: "6px",
  pb: "50px",
};

const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
  height: "100%",
};

const chartToggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  px: "8px",
  py: "6px",
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const chartToggleBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "12px",
  py: "5px",
  borderRadius: "8px",
  border: "1px solid",
  fontSize: "0.75rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

export default FuturesDashboard;
